"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const RoomCardAtoms_1 = require("../RoomCardAtoms");
function default_1({ channel_uid, channel_thumbnail, channel_name, }) {
    const channelLink = `/@${channel_uid}`;
    return ((0, jsx_runtime_1.jsxs)("a", Object.assign({ className: "no_anchor_deco", css: {
            display: 'flex',
            alignItems: 'center',
            columnGap: '4px',
        }, href: channelLink }, { children: [(0, jsx_runtime_1.jsx)(RoomCardAtoms_1.ChannelThumbnail, { channel_thumbnail: channel_thumbnail }), (0, jsx_runtime_1.jsx)(RoomCardAtoms_1.ChannelName, { channel_name: channel_name })] })));
}
exports.default = default_1;
